module.exports = __webpack_public_path__ + "img/slogan_main.fe5f6130.png";